// VOC Feedback Widget — localStorage helpers & constants

export const FEEDBACK_DISMISSED_KEY = "eagleEye_feedback_dismissed";
export const FEEDBACK_SUBMITTED_KEY = "eagleEye_feedback_submitted";
export const FEEDBACK_AUTO_OPEN_DELAY_MS = 60000;
export const FEEDBACK_AUTO_CLOSE_DELAY_MS = 3000;
export const FEEDBACK_DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
export const EAGLE_EYE_TOOL_NAME = "EagleEye";

/** Temporarily suppress auto-open for 30 days (user dismissed without submitting). */
export const dismissFeedback = (): void => {
    try {
        localStorage.setItem(FEEDBACK_DISMISSED_KEY, Date.now().toString());
    } catch {
        // localStorage unavailable — safe to ignore
    }
};

/** Permanently suppress auto-open (user submitted feedback). */
export const dismissFeedbackPermanent = (): void => {
    try {
        localStorage.setItem(FEEDBACK_SUBMITTED_KEY, "true");
    } catch {
        // localStorage unavailable — safe to ignore
    }
};

/** Returns true if the popup should NOT auto-open. */
export const isFeedbackDismissed = (): boolean => {
    try {
        if (localStorage.getItem(FEEDBACK_SUBMITTED_KEY) === "true") return true;

        const dismissed = localStorage.getItem(FEEDBACK_DISMISSED_KEY);
        if (!dismissed) return false;
        const ts = Number(dismissed);
        if (Number.isNaN(ts)) return false;
        return Date.now() - ts < FEEDBACK_DISMISS_TTL_MS;
    } catch {
        return true;
    }
};
